import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { AppService } from '@app/app.service';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { HelperService } from '@app/shared/services/helper.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-multi-tab',
  templateUrl: './multi-tab.component.html',
  styleUrls: ['./multi-tab.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonComponent],
})
export class MultiTabComponent implements OnInit {
  logoImage: string;
  monkeyImage: string;

  multitabCopies: Record<string, string> = {};

  get currentLang(): string {
    return this.translateService.currentLang;
  }

  private readonly helper = inject(HelperService);
  private readonly translateService = inject(TranslateService);
  private readonly appService = inject(AppService);

  ngOnInit(): void {
    this.logoImage = this.helper.getCloudServiceCdnContent(`/images/logo/logo-horizontal.png`);
    this.monkeyImage = this.helper.getCloudServiceCdnContent(`/images/shared/multitab_monkey.webp`);

    this.multitabCopies = {
      title: this.translateService.instant('multitab.title'),
      description: this.translateService.instant('multitab.description'),
      buttonLabel: this.translateService.instant('multitab.button.label'),
    };
  }

  playHere(): void {
    this.appService.reload();
  }
}
